import { InviteForm } from "@features/sign-up";

export const InvitePage = () => <InviteForm />;
